{
  "common.back": "Back",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.confirm": "Confirm",
  "common.continue": "Continue",
  "common.minus": "Decrease",
  "common.plus": "Increase",
  "common.loading": "Loading…",
  "search.title": "Find a ferry",
  "search.subtitle": "Pick your crossing, passengers and vehicle.",
  "search.directionRoundTrip": "Round trip",
  "search.directionOneWay": "One way",
  "search.journey": "Crossing",
  "search.journeyPlaceholder": "Pick a route",
  "search.outDate": "Outbound date",
  "search.retDate": "Return date",
  "search.journeyCard": "Route",
  "search.datesCard": "Dates",
  "search.datesPlaceholder": "Pick your dates",
  "search.pickReturn": "Return date missing",
  "search.passengersCard": "Passengers",
  "search.vehicleCard": "Vehicle",
  "search.animalsCard": "Pets",
  "search.vehicleNone": "No vehicle",
  "search.submit": "Search",
  "search.submitting": "Searching…",
  "passengers.title": "Passengers",
  "passengers.subtitle": "Pick number and ages",
  "passengers.adults": "Adults",
  "passengers.children": "Children",
  "passengers.babies": "Babies",
  "passengers.senior": "Senior",
  "passengers.junior": "Junior",
  "passengers.agesTitle": "Ages",
  "passengers.childrenAges": "Children ages",
  "passengers.babyAges": "Baby ages",
  "passengers.adult": "Adult",
  "passengers.child": "Child",
  "passengers.baby": "Baby",
  "passengers.years": "yrs",
  "passengers.total": "Total passengers",
  "vehicle.title": "Vehicle",
  "vehicle.typeNone": "None",
  "vehicle.typeBike": "Bike",
  "vehicle.typeCar": "Car",
  "vehicle.typeVan": "Van",
  "vehicle.typeMoto": "Motorbike",
  "vehicle.plate": "Plate number",
  "vehicle.searchBrand": "Search a brand…",
  "vehicle.searchModel": "Search a model…",
  "vehicle.luggageToggle": "Bulky luggage (roof rack)",
  "vehicle.luggageHeight": "Height",
  "vehicle.luggageLength": "Length",
  "vehicle.step.type": "Type",
  "vehicle.step.brand": "Brand",
  "vehicle.step.model": "Model",
  "vehicle.step.luggage": "Luggage",
  "vehicle.step.plate": "Plate",
  "vehicle.roof.none": "No roof rack",
  "vehicle.roof.with": "With roof rack",
  "vehicle.roof.heightExtra": "Extra height",
  "vehicle.trailer.title": "Caravan / Trailer",
  "vehicle.trailer.none": "No caravan/trailer",
  "vehicle.trailer.with": "With caravan/trailer",
  "vehicle.trailer.caravan": "Caravan",
  "vehicle.trailer.standard": "Standard trailer",
  "vehicle.trailer.lengthExtra": "Extra length",
  "vehicle.priority.title": "Disembarkation",
  "vehicle.priority.standard": "Standard",
  "vehicle.priority.priority": "Priority disembarkation",
  "vehicle.maxDims": "Max length {length}m (+{trailer}cm) / Max height {height}m (+{roof}cm)",
  "vehicle.summary.length": "Length",
  "vehicle.summary.height": "Height",
  "place.title": "Pick a seat",
  "place.titleInline": "Available seats",
  "place.empty": "No seats available for this trip.",
  "place.capacity": "{n} pax",
  "place.all": "All",
  "place.seat": "Seat",
  "place.cabin": "Cabin",
  "place.suite": "Suite",
  "place.bed": "Bed",
  "place.deck": "Deck passage",
  "place.shared": "Shared",
  "place.features.window": "Window",
  "place.features.shower": "Shower",
  "place.features.toilet": "Toilet",
  "results.choosePlace": "Pick a seat",
  "results.choosePlaceRequired": "Pick a seat (required)",
  "results.placeSelected": "Seat: {name}",
  "results.placeChosen": "Seat picked",
  "results.fastest": "FASTEST",
  "results.cheapest": "BEST PRICE",
  "results.pricePerPassenger": "for 1 passenger",
  "results.pricePerPassengers": "for {n} passengers",
  "results.choosePlaceCta": "Pick {dir} seat",
  "results.choose": "Choose {dir}",
  "results.chooseSailing": "Choose",
  "results.pickSailingHint": "Tap a sailing to pick your seat",
  "results.availableCount": "{n} crossings available",
  "results.startingFrom": "from",
  "results.selectToContinue": "Choose your crossing and seat to continue",
  "journey.title": "Your crossing",
  "journey.subtitle": "Choose your departure and destination",
  "journey.continueToDates": "Continue to dates",
  "journey.search": "Type a port or carrier…",
  "journey.empty": "No route found",
  "journey.clear": "Clear",
  "journey.loadingVariants": "Loading availability…",
  "journey.departureLabel": "Departure",
  "journey.destinationLabel": "Destination",
  "journey.choosePort": "Choose a port",
  "journey.destinationDisabled": "Select a departure first",
  "journey.stepDeparture": "Departure port",
  "journey.stepDestination": "Where are you going?",
  "journey.fromPrefix": "From {port}",
  "journey.searchPort": "Search a port…",
  "journey.noPortFound": "No port found",
  "journey.swap": "Swap direction",
  "journey.returnInfo": "Return: {to} → {from}",
  "journey.returnLabel": "Return",
  "calendar.title": "Pick your dates",
  "calendar.tabOutward": "Outbound",
  "calendar.tabReturn": "Return",
  "calendar.tabSelect": "Select",
  "calendar.empty": "Pick a route first to see departures.",
  "calendar.noDepartures": "No departures available on this route.",
  "calendar.addReturn": "Add a return",
  "calendar.departuresOn": "Departures on {date}",
  "calendar.noOutwardYet": "Pick the outbound date first",
  "calendar.weekday.mon": "Mon",
  "calendar.weekday.tue": "Tue",
  "calendar.weekday.wed": "Wed",
  "calendar.weekday.thu": "Thu",
  "calendar.weekday.fri": "Fri",
  "calendar.weekday.sat": "Sat",
  "calendar.weekday.sun": "Sun",
  "passengers.travelWithPets": "Travelling with pets?",
  "passengers.petsSection": "Pets",
  "animals.title": "Pets",
  "animals.subtitle": "Your companions onboard",
  "animals.cats": "Cats",
  "animals.dogs": "Dogs",
  "animals.dogs30": "Dogs > 30 kg",
  "animals.total": "Total pets",
  "tariff.title": "Pricing",
  "tariff.subtitle": "Choose your fare type",
  "tariff.outward": "Outward",
  "tariff.return": "Return",
  "tariff.ticket": "Standard fare",
  "tariff.presale": "Presale fare",
  "tariff.option": "Option (cancellable)",
  "tariff.balance": "Balance",
  "tariff.payToday": "Pay today",
  "tariff.remaining": "Remaining balance",
  "tariff.dueDate": "Due date",
  "tariff.optionValidUntil": "Option valid until",
  "tariff.presaleTitle": "Presale payment",
  "tariff.optionTitle": "Option payment",
  "tariff.presaleDesc": "The initial payment secures your booking. The remaining balance must be paid before the due date.",
  "tariff.optionDesc": "This option lets you reserve your seats until the deadline. Complete payment is required before expiration to issue tickets.",
  "tariff.onlyOne": "(only available fare)",
  "summary.empty": "Pick a journey to see the summary.",
  "summary.outward": "Outward",
  "summary.return": "Return",
  "summary.passengers": "Passengers",
  "summary.vehicle": "Vehicle",
  "summary.places": "Accommodation",
  "summary.placeOutward": "Outward seat",
  "summary.placeReturn": "Return seat",
  "summary.tariffOutward": "Outward fare",
  "summary.tariffReturn": "Return fare",
  "summary.total": "Total",
  "summary.group": "Group {group}",
  "summary.adult": "adult",
  "summary.adults": "adults",
  "summary.child": "child",
  "summary.children": "children",
  "summary.baby": "baby",
  "summary.babies": "babies",
  "results.stepSailing": "Sailing",
  "results.amenitiesInfo": "Vehicles, cabins and pets allowed on board",
  "results.stepPlace": "Choose your seat",
  "results.placeGroup": "Group {group} · {count} passengers",
  "results.stepTariff": "Fare",
  "results.title": "Your crossing",
  "results.subtitle": "Pick your departure, seating and fare.",
  "results.loading": "Loading availability…",
  "results.emptyTitle": "No availability",
  "results.emptyText": "No crossing matches your search for these dates. Try different dates or another route.",
  "results.newSearch": "New search",
  "results.searching": "Searching for crossings…",
  "results.errorTitle": "Search failed",
  "results.errorText": "We couldn't load availability right now. Check your connection and try again.",
  "results.retry": "Try again",
  "results.modifySearch": "Edit search",
  "steps.aria": "Booking progress",
  "steps.trip": "Crossing",
  "steps.options": "Options",
  "steps.details": "Details",
  "steps.summary": "Summary",
  "booking.subtitle": "A few more details to finalise.",
  "results.outwardTrip": "Outbound trip",
  "results.returnTrip": "Return trip",
  "results.continue": "Continue",
  "results.total": "Total",
  "results.noAvailabilityDate": "No availability for this date",
  "options.title": "Options",
  "options.subtitle": "Add meals and services to your crossing.",
  "options.outwardGroup": "Outward · Meals & services",
  "options.returnGroup": "Return · Meals & services",
  "options.none": "No meals or services available for this trip.",
  "options.service": "Service",
  "options.continue": "Continue",
  "booking.title": "Your details",
  "booking.passengers": "Passengers",
  "booking.passengersGroup": "Group {group} · {count} passengers",
  "booking.contact": "Contact",
  "booking.vehicle": "Vehicle",
  "booking.vehicleRoofExtra": "Roof rack +{cm} cm",
  "booking.passengerN": "Passenger {n}",
  "booking.firstName": "First name",
  "booking.lastName": "Last name",
  "booking.gender": "Gender",
  "booking.genderMale": "Male",
  "booking.genderFemale": "Female",
  "booking.birthDate": "Birth date",
  "booking.passportNumber": "Passport number",
  "booking.fullName": "Full name",
  "booking.email": "Email",
  "booking.phone": "Phone",
  "booking.submit": "Confirm and pay",
  "booking.submitting": "Processing…",
  "booking.required": "This field is required",
  "booking.invalidEmail": "Invalid email address",
  "booking.invalidPhone": "Invalid phone number",
  "booking.requiredHint": "All fields are required",
  "summary.title": "Trip summary",
  "summary.subtitle": "Review all information before continuing.",
  "summary.reference": "Reference",
  "summary.traveler": "Main traveler",
  "summary.otherTravelers": "Other travelers",
  "summary.arrival": "Arrival",
  "summary.duration": "Duration",
  "summary.durationFormat": "{hours}h {minutes}m",
  "summary.priceDetails": "Price details",
  "summary.tickets": "Tickets",
  "summary.meals": "Meals",
  "summary.taxesIncluded": "Taxes and fees included",
  "summary.trustSecure": "Secure payment",
  "summary.trustEncrypted": "Your data is encrypted",
  "summary.trustNoCardStored": "No card details stored",
  "summary.redirectInfo": "You will be redirected to a secure payment page.",
  "summary.passengerDetails": "Passenger details",
  "summary.passenger": "Passenger {n}",
  "summary.vehicleDetails": "Vehicle",
  "summary.vehiclePlate": "Plate",
  "summary.vehicleBrandModel": "{brand} {model}",
  "summary.contactDetails": "Contact",
  "summary.contactName": "Name",
  "summary.contactEmail": "Email",
  "summary.contactPhone": "Phone",
  "summary.placesDetails": "Accommodation",
  "summary.mealsDetails": "Meals",
  "summary.petsDetails": "Pets",
  "summary.b2cCta": "Proceed to payment",
  "summary.agentCta": "Continue in FerryGate",
  "summary.b2cHelper": "You will be redirected to the organisation's payment page.",
  "summary.agentHelper": "You will be redirected to the FerryGate confirmation page to issue the ticket.",
  "summary.redirecting": "Redirecting…",
  "summary.missingCheckoutUrl": "Checkout URL not configured — please contact the administrator.",
  "summary.checkoutUnavailable": "Payment temporarily unavailable. Please try again later.",
  "summary.missingBooking": "Booking not found, please restart your search.",
  "summary.newBooking": "New search",
  "summary.years": "y/o",
  "summary.notProvided": "Not provided",
  "search.passengersSummary": "{n} passenger | {n} passengers",
  "search.passengersDetail": "{adults} adult(s), {children} child(ren), {babies} infant(s)",
  "search.animalsSummary": "{n} pet | {n} pets",
  "summary.tariffsInclTaxes": "All taxes included",
  "booking.ageBand": "{min} to {max} years old at departure",
  "booking.ageBandAdult": "From {min} years old at departure",
  "booking.ageOutOfBand": "A {type} must be between {min} and {max} years old at departure",
  "booking.birthDateAfterDeparture": "Birth date cannot be after the departure"
}
